import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import { Tooltip } from "reactstrap";
import { useTranslation } from "react-i18next";
import { Badge } from "@mui/material";
//import { Badge, Button } from 'reactstrap';
// import Badge from '@mui/material/Badge';
// import PendingList from "../../views/PendingList/PendingList";

function Notification(props) {
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const { t } = useTranslation();

  const count = useSelector(({ plCount }) => plCount);

  const toggle = () => setTooltipOpen(!tooltipOpen);
  return (
    <div className="notification">
      <Link to="/index/pending-list" id="PendingList" style={{ fontSize: '18px', color: '#fff' }}>
        <Badge badgeContent={count.requestCount} showZero>
          <i className="fas fa-bell" />
        </Badge>
      </Link>
      <Tooltip
        placement="bottom"
        isOpen={tooltipOpen}
        target="PendingList"
        toggle={toggle}
      >
        {t("Pending List")}
      </Tooltip>
    </div>
  );
}

export default withRouter(Notification);
